import styles from './spinner.module.css';

export interface SpinnerProps {
  /** Optional label for a standalone spinner (e.g. a loading region). When a
   *  spinner sits inside a control that already carries `aria-busy`
   *  (Button/IconButton pending), leave this unset - it stays aria-hidden. */
  label?: string;
  className?: string;
}

/**
 * Spinner - the one busy indicator. A thin ring in `currentColor` sized to the
 * caller's `1em`, so it drops into any control or text run and inherits colour
 * and size with no token of its own. Decorative by default (aria-hidden); pass
 * `label` only for a standalone loading region that needs to announce itself.
 * The canonical consumers are Button/IconButton's `pending` state.
 */
export function Spinner({ label, className }: SpinnerProps) {
  return (
    <span
      className={className ? `${styles.spinner} ${className}` : styles.spinner}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
